webpackJsonp([1],Array(34).concat([
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./bier/bier_1.jpg": 170,
	"./bier/bier_2.jpg": 171,
	"./bier/bier_3.jpg": 172,
	"./fpoe/csm_p1_51be7bb656.png": 173,
	"./fpoe/csm_p2_12646ea39d.png": 174,
	"./fpoe/fpoe_1.jpg": 175,
	"./fpoe/fpoe_2.jpg": 176,
	"./gruene/2020_welle1_01_gesundesklima_quadrat (1).png": 177,
	"./gruene/2020_welle1_02_aufeinanderschaun_quadrat.png": 178,
	"./gruene/2020_welle1_03_klimajobs_quadrat.png": 179,
	"./gruene/Eg5Hq5sXcAEowG3.jpg": 180,
	"./gruene/Plakat_Wiederkehr-554x783.jpg": 181,
	"./gruene/gruene_1.jpg": 182,
	"./gruene/gruene_2.jpg": 183,
	"./gruene/gruene_3.jpg": 184,
	"./links/links_1.jpg": 185,
	"./links/links_2.jpg": 186,
	"./neos/118766452_3200624693366762_6729879700552210940_o.jpg": 187,
	"./neos/118770716_3200624786700086_922202680728232794_o.jpg": 188,
	"./neos/118774812_3200624596700105_8213178152654905177_o.jpg": 189,
	"./neos/Plakat_MeinlReisinger-554x783.jpg": 190,
	"./neos/Plakat_Wiederkehr-554x783 (1).jpg": 191,
	"./neos/neos_1.jpg": 192,
	"./neos/neos_2.jpg": 193,
	"./neos/neos_3.jpg": 194,
	"./oevp/11495-detailp.jpeg": 195,
	"./oevp/5d65034d-d421-4492-9e9d-014cb2e3a248.jpeg": 196,
	"./oevp/a09e1e9c-cc8b-4f4c-b340-187228f55949.jpeg": 197,
	"./oevp/oevp_1.jpg": 198,
	"./oevp/oevp_2.jpg": 199,
	"./spoe/01_bildung_spw_plakatprasentation_304x204mm_.jpg": 200,
	"./spoe/03_gesundheit_spw_plakatprasentation_304x204mm.jpg": 201,
	"./spoe/04_spw_plakatprasentation_304x204mm.jpg": 202,
	"./spoe/1.jpg": 203,
	"./spoe/11494-detailp.jpeg": 204,
	"./spoe/11497-detailp.jpeg": 205,
	"./spoe/4.png": 206,
	"./spoe/411.640.723.jpg": 207,
	"./spoe/411.640.726.jpg": 208,
	"./spoe/411.640.729.jpg": 209,
	"./spoe/440.358.357.jpg": 210,
	"./spoe/440.358.358.jpg": 211,
	"./spoe/440.358.360.jpg": 212,
	"./spoe/spoe_1.jpg": 213,
	"./spoe/spoe_2.jpg": 214,
	"./spoe/spoe_3.jpg": 215,
	"./spoe/spoe_4.jpg": 216,
	"./thc/118319302_193136218846021_1897832875975638081_o.jpg": 217,
	"./thc/thc_1.jpg": 218
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_spoe__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_gruene__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_oevp__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_fpoe__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_neos__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_thc__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_bier__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_links__ = __webpack_require__(151);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);










var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    currentParty: 'SPÖ',
    currentVersion: 'spoe/spoe_1.jpg',
    showDisclaimer: true,
    parties: [__WEBPACK_IMPORTED_MODULE_2__config_spoe__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__config_gruene__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__config_oevp__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__config_fpoe__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__config_neos__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__config_thc__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__config_bier__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__config_links__["a" /* default */]],
    lines: []
  },
  mutations: {
    setRemoteState: function setRemoteState(state, newState) {
      state.currentParty = newState.currentParty;
      state.currentVersion = newState.currentVersion;
      state.lines = newState.lines;
    },
    setDefaultLines: function setDefaultLines(state) {
      state.lines = state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).linesDefault;
    },
    setLines: function setLines(state, lines) {
      state.lines = lines;
    },
    setParty: function setParty(state, party) {
      // mutate state
      state.currentParty = party;
    },
    setVersion: function setVersion(state, version) {
      // mutate state
      state.currentVersion = version;
    },
    removeParty: function removeParty(state, index) {
      state.lines.splice(index, 1);
    },
    setDefaultVersion: function setDefaultVersion(state) {
      state.currentVersion = state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).versions[0];
    }
  },
  getters: {
    // returns all custom styles for current party
    getCustomStyles: function getCustomStyles(state) {
      return state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).customStyles;
    },
    // returns custom style of current party for type (index of custom style)
    getCustomStyle: function getCustomStyle(state, getters) {
      return function (type) {
        return getters.getCustomStyles[type].style;
      };
    },
    // returns base style of current party
    getBaseStyle: function getBaseStyle(state) {
      return state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).baseStyle;
    },
    // returns true if current parties blocks are rotated
    isRotated: function isRotated(state) {
      return state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).isRotated == true;
    },
    // returns all Versions of the political campaign for the current party
    getVersions: function getVersions(state) {
      return state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).versions;
    },
    getContainerStyle: function getContainerStyle(state) {
      var containerStyle = state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).containerStyle;
      console.log(containerStyle);
      if (containerStyle == undefined) {
        return {};
      }
      return containerStyle;
    },
    getCustomContainerStyles: function getCustomContainerStyles(state) {
      return state.parties.find(function (party) {
        return party.name == state.currentParty;
      }) && state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).customContainerStyles ? state.parties.find(function (party) {
        return party.name == state.currentParty;
      }).customContainerStyles : null;
    },
    getCustomContainerVersionStyle: function getCustomContainerVersionStyle(state, getters) {
      return getters.getCustomContainerStyles != null && getters.getCustomContainerStyles.find(function (style) {
        return style.name == state.currentVersion;
      }) ? getters.getCustomContainerStyles.find(function (style) {
        return style.name == state.currentVersion;
      }).style : {};
    }
  }
});

/***/ }),
/* 61 */,
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(141),
  /* template */
  __webpack_require__(230),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Builder_vue__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Builder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Builder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Selector_vue__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Selector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Selector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Badge__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Badge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Badge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Datenschutzerklaerung__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Datenschutzerklaerung___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Datenschutzerklaerung__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Builder: __WEBPACK_IMPORTED_MODULE_0__components_Builder_vue___default.a,
    Selector: __WEBPACK_IMPORTED_MODULE_1__components_Selector_vue___default.a,
    Badge: __WEBPACK_IMPORTED_MODULE_2__components_Badge___default.a,
    Datenschutzerklaerung: __WEBPACK_IMPORTED_MODULE_3__components_Datenschutzerklaerung___default.a
  },
  computed: {
    footer: function footer() {
      return 'made by Gregor Vostrak (<a href="https://twitter.com/onatcer">@onatcer</a>)  <br> contact, feedback etc. via twitter or <a href="mailto:gregor@vostrak.at">gregor@vostrak.at</a>';
    }
  }
});

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Badge'
});

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Block',
  props: {
    text: String,
    type: Number,
    fontSize: Number
  },
  computed: {
    fontSizeStyle: function fontSizeStyle() {
      return {
        fontSize: this.fontSize + "px"
      };
    },
    baseStyle: function baseStyle() {
      return this.$store.getters.getBaseStyle;
    },
    customStyle: function customStyle() {
      return this.$store.getters.getCustomStyle(this.type);
    }
  }
});

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Block_vue__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Block_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Block_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_to_image__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_dom_to_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_dom_to_image__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html2canvas___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_html2canvas__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Builder',
    components: {
        Block: __WEBPACK_IMPORTED_MODULE_0__components_Block_vue___default.a,
        Spinner: __WEBPACK_IMPORTED_MODULE_1__Spinner___default.a
    },
    data: function data() {
        return {
            loadingDownload: false,
            statusText: null
        };
    },

    computed: {
        styles: function styles() {
            return this.$store.getters.getCustomStyles;
        },
        containerStyle: function containerStyle() {
            return this.$store.getters.getContainerStyle;
        },
        customContainerVersionStyle: function customContainerVersionStyle() {
            return this.$store.getters.getCustomContainerVersionStyle;
        },
        imageLink: function imageLink() {
            return __webpack_require__(34)("./" + this.$store.state.currentVersion);
        },
        imageLinkBG: function imageLinkBG() {
            return "url(" + __webpack_require__(34)("./" + this.$store.state.currentVersion) + ")";
        },

        lines: {
            get: function get() {
                return this.$store.state.lines;
            },
            set: function set(value) {
                this.$store.state.lines = value;
            }
        },
        showDisclaimer: {
            get: function get() {
                return this.$store.state.showDisclaimer;
            },
            set: function set(value) {
                this.$store.state.showDisclaimer = value;
            }
        },
        isRotated: function isRotated() {
            return false;
            //return this.$store.getters.isRotated;
        },
        scaling: function scaling() {

            if (browserWidth < 1150) {
                return 'scale(' + browserWidth / 900 + ')';
            }

            return 'scale(1)';
            /* scaling the generator via CSS Transform so that element sizes stay
            usable in relation to each other */
            if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
                return 'scale(1)';
            }
            var browserWidth = Math.max(document.body.scrollWidth, document.documentElement.scrollWidth, document.body.offsetWidth, document.documentElement.offsetWidth, document.documentElement.clientWidth);
            if (browserWidth < 1150) {
                return 'scale(' + browserWidth / 900 + ')';
            }
        }
    },
    methods: {
        addLine: function addLine() {
            this.lines.push({
                fontSize: '60',
                text: 'Platzhalter',
                style: 0
            });
        },
        download: function download(event) {
            var _this = this;

            if (this.loadingDownload) {
                console.log("Cancel Download");
                return false;
            }
            var currentState = this.$store.state;
            this.loadingDownload = true;
            this.statusText = 'Ein kleiner Roboter macht das Bild für dich zum Download bereit. Das kann ein paar Sekunden dauern.';

            __WEBPACK_IMPORTED_MODULE_5_axios___default()({
                url:  true ? 'https://renderer.plakatgenerator.com' : 'http://renderer.plakatgenerator20.test',
                method: 'POST',
                responseType: 'blob', // important,
                data: currentState
            }).then(function (response) {
                var url = window.URL.createObjectURL(new Blob([response.data]));
                var link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'download.jpg');
                document.body.appendChild(link);
                link.click();
                _this.loadingDownload = false;
                _this.statusText = null;
            }).catch(function (error) {

                if (error.response.status === 429) {
                    this.statusText = 'Whoops. Du hast ein bisschen zu viele Bilder generiert, warte ein bisschen und versuch es später nochmal, oder mach einfach einen Screenshot';
                } else {
                    this.statusText = 'Whoops. Irgenwas ist schief gegangen. Sorry, versuchs in ein paar Minuten nochmal, im Zweifel kannst du auch einen Screenshot vom Plakat machen.';
                }
            });
        },
        removeLine: function removeLine(index) {
            this.$store.commit('removeParty', index);
        }
    }
});

function preRender() {
    /* scrolls to the top of the page and guarantee that the page is in a state so that the
    safari rendering works */
    try {
        window.scrollTo(0, 0);
        document.getElementById("viewport").setAttribute("content", 'content="width=1150px, initial-scale=0.1, maximum-scale=0.1, user-scalable=no');
    } catch (e) {
        document.write(e);
    }
}

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Datenschutzerklaerung',
  components: {},
  props: ['data'],
  computed: {},
  methods: {
    open: function open() {
      this.$modal.show('datenschutz', { height: 'auto' });
    }
  }
});

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Selector',
  data: function data() {
    return {
      imagesLoaded: 0
    };
  },
  computed: {
    parties: function parties() {
      return this.$store.state.parties;
    },
    loading: function loading() {
      return false;
    },
    partyLogo: function partyLogo() {
      var filename = this.currentParty;

      // replace umlauts and make it lower case
      filename = filename.toLowerCase();
      filename = filename.replace(/ä/g, 'ae');
      filename = filename.replace(/ö/g, 'oe');
      filename = filename.replace(/ü/g, 'ue');
      filename = filename.replace(/ß/g, 'ss');

      return '/static/' + filename + '.svg';
    },

    // get versions (for bg images) of current party
    versions: function versions() {
      return this.$store.getters.getVersions;
    },

    currentParty: {
      get: function get() {
        // when the current Party changes all blocks/lines need to be set to the new parties default
        this.$store.commit('setDefaultLines');
        return this.$store.state.currentParty;
      },
      set: function set(value) {
        this.$store.state.currentParty = value;
        this.$store.commit('setDefaultVersion');
      }
    },
    currentVersion: {
      get: function get() {
        return this.$store.state.currentVersion;
      },
      set: function set(value) {
        this.$store.state.currentVersion = value;
      }
    }

  },
  methods: {
    getImageLink: function getImageLink(url) {
      var image = __webpack_require__(34)("./" + url);
      return image;
    },
    isCurrentVersion: function isCurrentVersion(version) {
      return version == this.currentVersion;
    },
    setCurrentVersion: function setCurrentVersion(version) {
      this.currentVersion = version;
    }
  }
});

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: "spinner"
});

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Bier',
  isRotated: true,
  versions: ['bier/bier_1.jpg', 'bier/bier_2.jpg', 'bier/bier_3.jpg'],
  containerStyle: {
    paddingBottom: '15%',
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  baseStyle: {
    fontFamily: 'Arial',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textAlign: 'center',
    display: 'block',
    position: 'relative',
    lineHeight: '1',
    marginTop: '5px',
    marginBottom: '5px',
    fontWeight: 'bold',
    textShadow: '0px 0px 20px rgba(0,0,0,1)',
    hyphens: 'auto'
  },
  customStyles: [{
    name: "weiss",
    style: {
      color: '#FFFFFF'
    }
  }],
  customContainerStyles: [{
    name: 'bier/bier_2.jpg',
    style: {
      transform: 'rotate(-4deg)',
      paddingBottom: '12%'
    }
  }, {
    name: 'bier/bier_3.jpg',
    style: {
      paddingBottom: '105%'
    }
  }],
  linesDefault: [{
    text: 'Verpflichtendes Wegbier in der U-Bahn!',
    style: 0,
    fontSize: 60
  }]
});

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FPÖ',
  versions: ['fpoe/fpoe_1.jpg'],
  baseStyle: {
    fontFamily: '"Barlow",Helvetica,arial,"sans-serif"',
    color: '#FFFFFF',
    width: '80%',
    display: 'block',
    position: 'relative',
    marginTop: '2px',
    marginBottom: '8px',
    marginRight: '0px',
    paddingRight: '0px',
    lineHeight: '0.8'
  },
  containerStyle: {
    paddingBottom: '41%',
    paddingLeft: '15%'
  },
  customStyles: [{
    name: "dünn",
    style: {}
  }, {
    name: "dick",
    style: {
      fontWeight: '700',
      textTransform: 'uppercase'
    }
  }],
  linesDefault: [{
    text: 'Jö schau da:',
    style: 0,
    fontSize: 50
  }, {
    text: 'Ein Vogerl!',
    style: 1,
    fontSize: 100
  }]
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Grüne',
  isRotated: true,
  versions: ['gruene/gruene_2.jpg', 'gruene/gruene_3.jpg'],
  containerStyle: {
    paddingBottom: '20%'
  },
  baseStyle: {
    fontFamily: '"Gotham Narrow", "Open Sans", sans-serif',
    letterSpacing: '-1px',
    textTransform: 'uppercase',
    textAlign: 'center',
    padding: '10px',
    display: 'block',
    position: 'relative',
    lineHeight: '0.8',
    transform: 'rotate(-5deg)',
    margin: '0 auto',
    width: '70%',
    textShadow: '0px 0px 10px rgba(0,0,0,0.3)',
    fontStyle: 'italic',
    marginTop: '5px',
    marginBottom: '5px'
  },

  customStyles: [{
    name: "gelb",
    style: {
      color: '#FFF000'
    }
  }, {
    name: "weiss",
    style: {
      color: '#FFF'
    }
  }, {
    name: "pink",
    style: {
      color: '#fe01ac'
    }
  }, {
    name: "grün",
    style: {
      color: 'rgb(132,180,20)'
    }
  }],
  linesDefault: [{
    text: 'WER GRANTLT RUM, WENN NICHT WIEN?',
    style: 0,
    fontSize: 60
  }, {
    text: '#Wienistgleicher',
    style: 1,
    fontSize: 30
  }]
});

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Links',
  isRotated: true,
  versions: ['links/links_1.jpg', 'links/links_2.jpg'],
  containerStyle: {
    paddingBottom: '10%',
    paddingLeft: '5%',
    paddingRight: '5%'
  },
  baseStyle: {
    fontFamily: 'Roboto',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textAlign: 'center',
    display: 'block',
    position: 'relative',
    lineHeight: '1',
    padding: '10px',
    marginTop: '5px',
    marginBottom: '5px',
    fontWeight: 'bold',
    hyphens: 'auto'
  },
  customStyles: [{
    name: "violette box",
    style: {
      color: '#FFFFFF',
      backgroundColor: '#502583',
      textShadow: 'none'
    }
  }, {
    name: "weiss",
    style: {
      color: '#FFFFFF'
    }
  }, {
    name: "orange",
    style: {
      color: '#EC7204'
    }
  }],
  customContainerStyles: [{
    name: 'links/links_1.jpg',
    style: {
      textShadow: '0px 0px 30px rgba(0,0,0,0.5)'
    }
  }, {
    name: 'links/links_2.jpg',
    style: {
      paddingBottom: '30%'
    }
  }],
  linesDefault: [{
    text: 'Kommunismus',
    style: 0,
    fontSize: 80
  }, {
    text: 'sagt man nicht',
    style: 1,
    fontSize: 70
  }]
});

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NEOS',
  versions: ['neos/neos_1.jpg', 'neos/neos_2.jpg', 'neos/neos_3.jpg'],
  baseStyle: {
    fontFamily: '"Montserrat", "Gotham Narrow", "Open Sans", sans-serif',
    letterSpacing: '1px',
    textAlign: 'center',
    display: 'block',
    position: 'relative',
    lineHeight: '1.2',
    marginTop: '5px',
    marginBottom: '5px',
    textTransform: 'uppercase'
  },
  containerStyle: {
    paddingBottom: '15%',
    paddingRight: '10%',
    paddingLeft: '10%',
    textAlign: 'center'
  },
  customStyles: [{
    name: "pink",
    style: {
      color: '#FFF',
      boxShadow: '10px 0 0 #e84189, -10px 0 0 #e84189',
      display: 'inline',
      backgroundColor: '#e84189'
    }
  }, {
    name: "gelb",
    style: {

      color: '#e84189',
      boxShadow: '10px 0 0 #FCEB00, -10px 0 0 #FCEB00',
      display: 'inline',
      backgroundColor: '#FCEB00',
      transform: 'rotate(-5deg)',
      maxWidth: '70%'
    }
  }],
  linesDefault: [{
    text: 'Durch die pinke Brille schaun',
    style: 0,
    fontSize: 70
  }, {
    text: 'Weil eh schon ois wurscht is',
    style: 1,
    fontSize: 45
  }]
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ÖVP',
  versions: ['oevp/oevp_1.jpg', 'oevp/oevp_2.jpg'],
  containerStyle: {
    paddingBottom: '10%',
    paddingRight: '10%',
    paddingLeft: '10%'
  },
  baseStyle: {
    fontFamily: '"Geomanist",arial,"sans-serif"',
    fontWeight: '500',
    color: '#FFFFFF',
    display: 'table',
    position: 'relative',
    letterSpacing: '-1px',
    lineHeight: '1.05',
    textShadow: '0px 0px 50px rgba(0,0,0,0.5)'
  },
  customStyles: [{
    name: "gross",
    style: {
      textAlign: 'left',
      textDecoration: 'underline',
      maxWidth: '70%'
    }
  }],
  linesDefault: [{
    text: 'Fehlende Nullen für Wien.',
    style: 0,
    fontSize: 70
  }]
});

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'SPÖ',
  versions: ["spoe/spoe_4.jpg", 'spoe/spoe_1.jpg', "spoe/spoe_2.jpg", "spoe/spoe_3.jpg"],
  containerStyle: {
    textAlign: 'left',
    paddingBottom: '10%',
    paddingLeft: '5%',
    paddingRight: '40%'
  },

  baseStyle: {
    fontFamily: 'Arial',
    letterSpacing: '-2px',
    fontWeight: '600',
    padding: '3px 15px',
    lineHeight: '0.9',
    textShadow: '0px 0px 70px rgba(0,0,0,0.9)',
    position: 'relative',
    top: '10px'
  },

  customStyles: [{
    name: "rot",
    style: {
      color: '#EC1B26'
    }
  }, {
    name: "weiss",
    style: {
      color: '#FFF'
    }
  }],
  linesDefault: [{
    text: 'Schaut her, schaut her ich hab einen Plan',
    style: 1,
    fontSize: 60
  }]
});

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'THC',
  isRotated: true,
  versions: ['thc/thc_1.jpg'],
  containerStyle: {
    paddingBottom: '20%',
    paddingLeft: '45%',
    paddingRight: '5%'
  },
  baseStyle: {
    fontFamily: '"Destroy Earth", sans-serif',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    textAlign: 'left',
    display: 'inline-block',
    position: 'relative',
    lineHeight: '0.8',
    marginTop: '5px',
    marginBottom: '5px'
  },
  customStyles: [{
    name: "blau",
    style: {
      color: '#143352'
    }
  }, {
    name: "rote box",
    style: {
      color: '#FFFFFF',
      backgroundColor: '#DC0D1B',
      padding: '12px 12px 8px 12px'
    }
  }],
  linesDefault: [{
    text: 'Tigern Sie zum Loewen!',
    style: 0,
    fontSize: 70
  }, {
    text: 'Brille: Fielmann.',
    style: 1,
    fontSize: 30
  }]
});

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_lazyload__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_browser__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sentry_integrations__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_tracing__ = __webpack_require__(59);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_lazyload__["a" /* default */]);





__WEBPACK_IMPORTED_MODULE_4__sentry_browser__["a" /* init */]({
  dsn: "https://3004116c8b09494eae402f5e32281ff5@o291654.ingest.sentry.io/5454833",
  integrations: [new __WEBPACK_IMPORTED_MODULE_5__sentry_integrations__["a" /* Vue */]({
    Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */],
    tracing: true
  }), new __WEBPACK_IMPORTED_MODULE_6__sentry_tracing__["a" /* Integrations */].BrowserTracing()],

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0
});

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
var vm = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

window.vm = vm;

/***/ }),
/* 157 */,
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bier_1.ef3eb84.jpg";

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bier_2.f30ab07.jpg";

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bier_3.c38629a.jpg";

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/csm_p1_51be7bb656.ad91efd.png";

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/csm_p2_12646ea39d.ef8d73e.png";

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fpoe_1.47acf04.jpg";

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fpoe_2.e71c2b1.jpg";

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2020_welle1_01_gesundesklima_quadrat (1).e3859d3.png";

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2020_welle1_02_aufeinanderschaun_quadrat.8c68c46.png";

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2020_welle1_03_klimajobs_quadrat.2ad26ba.png";

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Eg5Hq5sXcAEowG3.bfa159a.jpg";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Plakat_Wiederkehr-554x783.1635e54.jpg";

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gruene_1.e870f7c.jpg";

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gruene_2.9a3add8.jpg";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gruene_3.d6680f9.jpg";

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/links_1.a0351b8.jpg";

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/links_2.66234a8.jpg";

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/118766452_3200624693366762_6729879700552210940_o.86ed2be.jpg";

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/118770716_3200624786700086_922202680728232794_o.4059d31.jpg";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/118774812_3200624596700105_8213178152654905177_o.1a3a885.jpg";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Plakat_MeinlReisinger-554x783.e921d4c.jpg";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/Plakat_Wiederkehr-554x783 (1).1635e54.jpg";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/neos_1.ded8287.jpg";

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/neos_2.990b38a.jpg";

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/neos_3.9da79f7.jpg";

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11495-detailp.2ffd9c3.jpeg";

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5d65034d-d421-4492-9e9d-014cb2e3a248.ac4ba0c.jpeg";

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/a09e1e9c-cc8b-4f4c-b340-187228f55949.aa290b7.jpeg";

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oevp_1.e345a0e.jpg";

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oevp_2.756b255.jpg";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/01_bildung_spw_plakatprasentation_304x204mm_.e6e395e.jpg";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/03_gesundheit_spw_plakatprasentation_304x204mm.542dbff.jpg";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/04_spw_plakatprasentation_304x204mm.c139c43.jpg";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.3b410d0.jpg";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11494-detailp.1926dd3.jpeg";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/11497-detailp.4a52c18.jpeg";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.7890923.png";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/411.640.723.412b63f.jpg";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/411.640.726.7e9aa78.jpg";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/411.640.729.d9e0add.jpg";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/440.358.357.79513af.jpg";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/440.358.358.000d0b4.jpg";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/440.358.360.0aa12bb.jpg";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spoe_1.7f9d9cc.jpg";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spoe_2.f3b10a0.jpg";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spoe_3.964f51d.jpg";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/spoe_4.a3e89a5.jpg";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/118319302_193136218846021_1897832875975638081_o.4c51819.jpg";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/thc_1.820ef66.jpg";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(162)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(142),
  /* template */
  __webpack_require__(229),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-63efb351",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(225),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1a02573b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(161)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(144),
  /* template */
  __webpack_require__(228),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-51e4fdc9",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(159)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(145),
  /* template */
  __webpack_require__(226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-42216082",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(164)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(231),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c357bebe",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var Component = __webpack_require__(8)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(227),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-50665147",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "line",
    style: ([_vm.baseStyle, _vm.customStyle, _vm.fontSizeStyle]),
    domProps: {
      "textContent": _vm._s(_vm.text)
    }
  })
},staticRenderFns: []}

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile"
  }, [_c('details', [_c('summary', [_vm._v("Datenschutzerklärung & Impressum")]), _vm._v(" "), _c('h2', [_vm._v("Datenschutzerklärung")]), _vm._v("\n    Auf dieser Website werden unter Einsatz der Webanalysedienst-Software Matomo (www.matomo.org), einem Dienst\n    des Anbieters InnoCraft Ltd., 150 Willis St, 6011 Wellington, Neuseeland, („Mataomo“) auf Basis unseres\n    berechtigten Interesses an der statistischen Analyse des Nutzerverhaltens zu Optimierungs- und\n    Marketingzwecken gemäß Art. 6 Abs. 1 lit. f DSGVO Daten gesammelt und gespeichert. Aus diesen Daten können\n    zum selben Zweck pseudonymisierte Nutzungsprofile erstellt und ausgewertet werden. Hierzu können Cookies\n    eingesetzt werden. Bei Cookies handelt es sich um kleine Textdateien, die lokal im Zwischenspeicher des\n    Internet-Browsers des Seitenbesuchers gespeichert werden. Die Cookies ermöglichen unter anderem die\n    Wiedererkennung des Internet-Browsers. Die mit der Matomo-Technologie erhobenen Daten (einschließlich Ihrer\n    pseudonymisierten IP-Adresse) werden auf unseren Servern verarbeitet. .\n    Die durch das Cookie erzeugten Informationen im pseudonymen Nutzerprofil werden nicht dazu benutzt, den\n    Besucher dieser Website persönlich zu identifizieren und nicht mit personenbezogenen Daten über den Träger\n    des Pseudonyms zusammengeführt.\n    Wenn Sie mit der Speicherung und Auswertung dieser Daten aus Ihrem Besuch nicht einverstanden sind, dann\n    können Sie der Speicherung und Nutzung nachfolgend per Mausklick jederzeit widersprechen. In diesem Fall\n    wird in Ihrem Browser ein sog. Opt-Out-Cookie abgelegt, was zur Folge hat, dass Matomo keinerlei\n    Sitzungsdaten erhebt. Bitte beachten Sie, dass die vollständige Löschung Ihrer Cookies zur Folge hat, dass\n    auch das Opt-Out-Cookie gelöscht wird und ggf. von Ihnen erneut aktiviert werden muss.\n    "), _c('br'), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "border": "0",
      "height": "200px",
      "width": "600px"
    },
    attrs: {
      "src": "https://matomo.onatcer.com/index.php?module=CoreAdminHome&action=optOut&language=de&backgroundColor=&fontColor=&fontSize=&fontFamily="
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Impressum")]), _vm._v(" "), _c('p', [_vm._v("Gregor Vostrak")]), _vm._v(" "), _c('p', [_vm._v("Unternehmensgegenstand: Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnik")]), _vm._v(" "), _c('p', [_vm._v("UID-Nr.: ATU73800728")]), _vm._v(" "), _c('p', [_vm._v("Sitz: Türkenstraße 19/1B, 1090 Wien, Österreich")]), _vm._v(" "), _c('p', [_vm._v("Mail: gregor /at/ vostrak /dot/ at")]), _vm._v(" "), _c('p', [_vm._v("Telefonnummer: /plus/ 436801111642")])])])
}]}

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_vm._v("asd")])
},staticRenderFns: []}

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "boxborder",
    style: ({
      transform: _vm.scaling
    }),
    attrs: {
      "id": "boxborder"
    }
  }, [_c('div', {
    attrs: {
      "id": "generatorcontainer"
    }
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('img', {
    style: ({
      backgroundImage: _vm.imageLinkBG
    }),
    attrs: {
      "src": _vm.imageLink
    }
  }), _vm._v(" "), _c('ul', {
    class: {
      rotated: _vm.isRotated
    },
    style: ([_vm.containerStyle, _vm.customContainerVersionStyle]),
    attrs: {
      "id": "textcontainer"
    }
  }, [_vm._l((_vm.lines), function(line) {
    return _c('block', {
      attrs: {
        "real-time": true,
        "text": line.text,
        "type": line.style,
        "fontSize": line.fontSize
      }
    })
  }), _vm._v(" "), _c('br'), _c('br')], 2)]), _vm._v(" "), (_vm.showDisclaimer) ? _c('div', {
    staticStyle: {
      "font-weight": "500",
      "width": "100%",
      "text-align": "center",
      "color": "#999",
      "font-size": "14px",
      "padding": "10px 20px",
      "background-color": "#EEE"
    }
  }, [_vm._v("Dies Meisterwerk ist kein offizielles Plakat, es wurde mit "), _c('strong', {
    staticStyle: {
      "opacity": "0.9",
      "background-image": "linear-gradient(-70deg, #3023AE, #C86DD7)",
      "-webkit-background-clip": "text",
      "-webkit-text-fill-color": "transparent"
    }
  }, [_vm._v("plakatgenerator.com")]), _vm._v(" erstellt")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "builder"
  }, [_vm._l((_vm.lines), function(line, index) {
    return _c('div', {
      staticClass: "builder-line"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.text),
        expression: "line.text"
      }],
      staticClass: "input",
      attrs: {
        "name": "",
        "value": ""
      },
      domProps: {
        "value": (line.text)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(line, "text", $event.target.value)
        }
      }
    }), _c('br'), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding": "5px 0",
        "margin-top": "5px"
      }
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v("GRÖSSE:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.fontSize),
        expression: "line.fontSize"
      }],
      attrs: {
        "type": "range",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (line.fontSize)
      },
      on: {
        "__r": function($event) {
          return _vm.$set(line, "fontSize", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.fontSize),
        expression: "line.fontSize"
      }],
      attrs: {
        "type": "number",
        "min": "0",
        "max": "100"
      },
      domProps: {
        "value": (line.fontSize)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(line, "fontSize", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-bottom": "5px"
      }
    }, [_c('label', {
      staticClass: "label"
    }, [_vm._v("STIL:")]), _vm._v(" "), _c('div', {
      staticClass: "select is-small"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (line.style),
        expression: "line.style"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(line, "style", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.styles), function(style, index) {
      return _c('option', {
        domProps: {
          "value": index
        }
      }, [_c('div', {
        staticStyle: {
          "width": "10px",
          "height": "10px",
          "background-color": "red"
        }
      }, [_vm._v(_vm._s(style.name))])])
    }), 0)]), _vm._v(" "), _c('button', {
      staticClass: "button is-small",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "type": "button",
        "name": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeLine(index)
        }
      }
    }, [_vm._v("\n           X\n         ")])])])
  }), _vm._v(" "), _c('button', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": _vm.addLine
    }
  }, [_vm._v("Box Hinzufügen\n     ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "disclaimer",
    staticStyle: {
      "max-width": "800px"
    }
  }, [_c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.showDisclaimer),
      expression: "showDisclaimer"
    }],
    staticStyle: {
      "margin": "5px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.showDisclaimer) ? _vm._i(_vm.showDisclaimer, null) > -1 : (_vm.showDisclaimer)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.showDisclaimer,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showDisclaimer = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.showDisclaimer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.showDisclaimer = $$c
        }
      }
    }
  }), _vm._v(" "), _c('strong', [_vm._v("Disclaimer anzeigen?")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-left": "27px",
      "padding-top": "5px"
    }
  }, [_vm._v("Aus Gründen sind die diesjährigen Plakate standardmäßig mit einem Disclaimer versehen, dass es sich nicht um ein offizielles Plakat handelt. Situationselastisch kann er mit dieser Checkbox entfernt werden.")])])]), _vm._v(" "), _c('div', {
    staticClass: "download"
  }, [_c('a', {
    class: {
      disabled: _vm.loadingDownload
    },
    attrs: {
      "name": "button",
      "id": "downloadbutton"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("DOWNLOAD\n       "), (_vm.loadingDownload) ? _c('spinner', {
    staticStyle: {
      "top": "-3px",
      "margin-left": "10px"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.statusText) ? _c('p', {
    staticStyle: {
      "max-width": "500px",
      "margin": "20px auto"
    }
  }, [_vm._v(_vm._s(_vm.statusText))]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('a', {
    staticClass: "badge",
    attrs: {
      "href": "https://onatcer.com"
    }
  }, [_c('img', {
    attrs: {
      "width": "35",
      "height": "35",
      "src": "/static/onatcer.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', [_vm._v("made by Gregor Vostrak (@onatcer)")])])])
}]}

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('selector'), _vm._v(" "), _c('builder'), _vm._v(" "), _c('p', {
    staticClass: "contact",
    domProps: {
      "innerHTML": _vm._s(_vm.footer)
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('datenschutzerklaerung'), _vm._v(" "), _c('badge')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "contact"
  }, [_c('strong', {
    staticStyle: {
      "color": "#AAAAAA"
    }
  }, [_vm._v("Hinweis im allgemein öffentlichen Interesse:")]), _c('br'), _vm._v("\n    Da es immer wieder nicht verstanden wird: Dies ist ein satirisches Projekt welches von keinerlei Parteien oder\n    sonstigen politischen Organisationen unterstützt wird.\n    Dieses Projekt hat keine politische Agenda und ist nicht für die usergenerierten Inhalte die daraus hervorgehen verantwortlich.\n    Sollten dargestellte Personen oder anderweitig in die Plakate involvierte Personen Probleme mit dieser Art der Repräsentation haben, möge eine E-Mail an "), _c('a', {
    attrs: {
      "href": "mailto:gregor@vostrak.com"
    }
  }, [_vm._v("gregor@vostrak.com")]), _vm._v(" erfolgen.\n  ")])
}]}

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selector"
  }, [_c('div', {
    staticClass: "control has-icons-left"
  }, [_c('div', {
    staticClass: "select is-medium",
    staticStyle: {
      "margin-bottom": "7px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentParty),
      expression: "currentParty"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentParty = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.parties), function(party) {
    return _c('option', {
      domProps: {
        "value": party.name
      }
    }, [_vm._v("\n            " + _vm._s(party.name) + "\n          ")])
  }), 0)]), _vm._v(" "), _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('img', {
    attrs: {
      "src": _vm.partyLogo,
      "width": "20px;",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "versionselect clearfix"
  }, [(_vm.loading) ? _c('p', [_vm._v("Loading")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.versions), function(version) {
    return _c('a', {
      directives: [{
        name: "lazy-container",
        rawName: "v-lazy-container",
        value: ({
          selector: 'img'
        }),
        expression: "{ selector: 'img' }"
      }],
      staticClass: "navbar-item",
      class: {
        'is-active': _vm.isCurrentVersion(version)
      },
      on: {
        "click": function($event) {
          return _vm.setCurrentVersion(version)
        }
      }
    }, [_c('img', {
      staticClass: "image-version",
      attrs: {
        "data-src": _vm.getImageLink(version)
      }
    })])
  })], 2)])])
},staticRenderFns: []}

/***/ })
]),[156]);


// WEBPACK FOOTER //
// static/js/app.3ffbd4298912dadc90c8.js